import React from 'react'
import DeletionContent from './DeletionContent'

export default function DeletionPage () {
  return (
    <div className='deletionPage web'>
      <DeletionContent redirectUri={'/auth/logout'} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/deletion/DeletionPage.jsx